import { GetValuesOfEnum, PharmacyRoleEnum, RolesEnum } from "enum"
import JwtData from "./JwtData"

// Checks if the user has admin role
export const isAdmin = (): boolean => {
  const roles = (new JwtData()).roles()
  return (
    roles?.indexOf(RolesEnum.ADMIN) >= 0
  )
}

/// Returns true if the user is just a public user not pharmacy or admin
export const isJustPublic = (): boolean => {
  const roles = new JwtData().roles()
  const isPublic =
    roles?.indexOf(RolesEnum.PUBLIC) >= 0 ||
    roles?.indexOf(RolesEnum.USERS) >= 0
  const isPharmacy =
    roles?.indexOf(RolesEnum.PHARMACY) >= 0 ||
    roles?.some((item: any) =>
      GetValuesOfEnum(PharmacyRoleEnum).includes(item),
    )
  const isAdmin = roles?.indexOf(RolesEnum.ADMIN) >= 0
  const isPublicAndNotPharmacyOrAdmin = isPublic && !(isPharmacy || isAdmin)
  return isPublicAndNotPharmacyOrAdmin
}

/// Checks if the current user is just a pharmacy not an admin
export const isJustPharmacy = (): boolean => {
  let rolesArray = (new JwtData()).rolesFromMainToken()
  const isPharmacy =
    rolesArray?.indexOf(RolesEnum.PHARMACY) >= 0 ||
    rolesArray?.some((item: any) =>
      GetValuesOfEnum(PharmacyRoleEnum).includes(item),
    )
  const isAdmin = rolesArray?.indexOf(RolesEnum.ADMIN) >= 0
  const isPharmacyAndNotAdmin = isPharmacy && !isAdmin
  return isPharmacyAndNotAdmin
}
